module.exports = __webpack_public_path__ + "static/img/icon_cloud6.c9f57a0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/cloud/images/icon_cloud6.jpg
// module id = gd6n
// module chunks = 21